import { AIRevision } from 'components/AIRevision/AIRevision'
import { Revision } from 'types'
import { useStepper } from 'components/AIRevision/Stepper/StepperProvder'

interface Props {
  revisions: Revision[]
  articleId: string
  layerId: string
  customPrompt: string
  onPromptChange: (prompt: string) => any
}

export const AIRevisions = ({ revisions, layerId, articleId, customPrompt, onPromptChange }: Props) => {
  const { step } = useStepper()

  const revision = revisions[step - 1]

  if (!revision) return null

  return (
    <AIRevision
      revision={revision}
      articleId={articleId}
      layerId={layerId}
      customPrompt={customPrompt}
      onPromptChange={onPromptChange}
    />
  )
}
